import { render, staticRenderFns } from "./StepSummary.vue?vue&type=template&id=5c8b8579"
import script from "./StepSummary.vue?vue&type=script&lang=js"
export * from "./StepSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports